import SvgIcon from '@material-ui/core/SvgIcon';
import React from 'react';

const CostIcon = ({ className }) => (
  <SvgIcon viewBox='0 0 15.876 15.876' className={className}>
    <path id="Path_13144" data-name="Path 13144" fill="#ff633e" d="M4.5,4.473H14.9a2.418,2.418,0,0,0,2.738-2.711V-8.7A2.415,2.415,0,0,0,14.9-11.4H4.5A2.412,2.412,0,0,0,1.765-8.7V1.762A2.418,2.418,0,0,0,4.5,4.473Zm1.6-7.154a.777.777,0,0,1-.88-.78.777.777,0,0,1,.88-.8h7.208a.769.769,0,0,1,.87.8.769.769,0,0,1-.87.78Z" transform="translate(-1.765 11.404)"/>
  </SvgIcon>
);

export default CostIcon;
